export enum AppEnv {
    LOCAL = 'local',
    DEV = 'dev',
    TEST = 'test',
}
export const getEnvironment = (): string => {
    const { href } = window.location;
    switch (true) {
        case /localhost/.test(href):
            return AppEnv.LOCAL;
        case /-dev/.test(href):
            return AppEnv.DEV;
        case /-test/.test(href):
            return AppEnv.TEST;
    }
    return '';
};
